import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React, { Component } from 'react';
import { Sanction } from './Sanction';
import './Sanctions.js.css';

export class Sanctions extends Component {
    obtenirDelai() {
        const { delaiChiffre, delaiLettre, uniteTemps } = this.props.delai;
        return `${delaiLettre} (${delaiChiffre}) ${uniteTemps} `;
    }
    avecSantions() {
        return (
            <>
                <h4>
                    Récapitulatif des enquêtes effectuées
                </h4>
                <p>
                    Cette page vous présente la liste des enquêtes pénales effectuées pour le service de garde sélectionné.
                    Vous pouvez accéder à la fiche détaillée de chaque enquête pour lesquelles des poursuites pénales ont été
                    intentées en cliquant sur le bouton « <KeyboardArrowDownIcon /> » qui s’affiche lorsque des infractions sont constatées.
                </p>
                <h4>
                    Retrait des enquêtes et des infractions
                </h4>
                <p>
                    Les enquêtes réalisées depuis plus de {this.obtenirDelai()} ont été retirées de ce récapitulatif.
                </p>
            </>
        );
    }

    sansSantions() {
        return (
            <>
                <h4>
                    Récapitulatif des sanctions pénales
                </h4>
                <p>
                    Pour ce service de garde, il n'y a pas d'information disponible liée aux sanctions pénales.
                </p>
                <h4>
                    Retrait des sanctions pénales
                </h4>
                <p>
                    Les sanctions pénales de plus de {this.obtenirDelai()} ont été retirées de ce récapitulatif.
                </p>
            </>
        );
    }

    render() {
        const { sanctions } = this.props;

        if (sanctions && sanctions.length === 0) {
            return (
                <div className='sanctions'>
                    {this.sansSantions()}
                </div>
            );
        }
        return (
            <div className='sanctions'>
                {this.avecSantions()}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell size='small' />
                                <TableCell>Date de jugement</TableCell>
                                <TableCell>Nombre d'infraction</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sanctions.map((sanction, indexe) => (
                                <Sanction key={sanction.nombreInfractions + indexe} sanction={sanction} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div >
        );
    }
}

